import React from "react";
import BaseLayout from "layouts/base-layout";

const NotFound = ({ pageContext, location }) => {
  const { meta, settings } = pageContext;

  return (
    <BaseLayout meta={meta} data={settings} location={location}>
      <div style={styles.container}>
        <h1 style={styles.title}>404</h1>
        <p style={styles.subtitle}>Oops! Page not found.</p>
        <p style={styles.description}>
          We're sorry, but the page you are looking for does not exist.
        </p>
        <a className="btn btn-primary" href="/">
          Go to Homepage
        </a>
      </div>
    </BaseLayout>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  title: {
    fontSize: "8rem",
    marginBottom: "0.5rem",
  },
  subtitle: {
    fontSize: "2rem",
    marginBottom: "2rem",
  },
  description: {
    fontSize: "1.2rem",
    marginBottom: "2rem",
  },
};

export default NotFound;
